import 'bootstrap_css';
import 'app_css';
import logo from './assets/images/logo.png';
import logo_vessel from './assets/images/logo_vessel.png';
import bureau_vessel from './assets/images/bureau_logo.png';
import './scripts/main.js';
import './scripts/form-main.js'; 
import './scripts/dual-screen.js';
import './scripts/image-compressor.js';
import * as keyboardHandler from './scripts/keyboardHandler.js';
import { clearStorageOnClose } from './scripts/clearStorage.js';
import './scripts/pdf_viewer.js';
import './scripts/pdf_compressor';
import './scripts/excel_compressor/excelCompression.js';
import './scripts/excel_compressor/excelProcessing.js';

window.getWebpackImagePath = function () { return logo;};
window.getVesselLogoImagePath = function () { return logo_vessel;};
window.getCertificationLogo = function () { return bureau_vessel; };

window.keyboardHandler = keyboardHandler;
clearStorageOnClose();